import React, { useState } from 'react';

import Badge from 'components/Badge';
import Overlay from 'components/Overlay/Overlay';
import CaseStudyOverlay from 'components/Overlays/CaseStudyOverlay/CaseStudyOverlay';
import PullStats from 'components/PullStats/PullStats';
import Quote from 'components/Quote/Quote';
import Text from 'components/Text/Text';
import VideoBlock from 'components/VideoBlock/VideoBlock';
import useOverElement from 'hooks/useOverElement';
import { useCopyStore } from 'store';
import { handleMouseEnter, handleMouseLeave } from 'utils/cursorGlobal';
import {
  CMSSectionContentType,
  MultiSectionCMS,
} from 'utils/sharedStrapiQueries/sharedTypes';

import * as S from './MultiSection.styles';

const TextComponent = ({ optionalSubheading }) => (
  <S.RichText richText={optionalSubheading} />
);

const SECTION_COMPONENTS: {
  [key in CMSSectionContentType]?: React.FunctionComponent<any>;
} = {
  image: S.MultisectionContentMedia,
  video: VideoBlock,
  empty: () => <></>,
  text: TextComponent,
  quote: Quote,
  pullStat: PullStats,
};

const alignments = {
  top: 'start',
  center: 'center',
  bottom: 'end',
};

const MultiSection: React.FunctionComponent<MultiSectionCMS> = ({
  multiSection,
  overlay,
  caseStudy,
}) => {
  const { globalSettings } = useCopyStore(({ copy }) => copy);
  const [showOverlay, setShowOverlay] = useState(false);

  const [ref] = useOverElement();

  return (
    <>
      {multiSection.map(
        ({ width, alignment, contentType, id, optionalCtaButton, ...rest }) => {
          const styleProps = {
            $spanWidth: width,
            alignment: alignments[alignment],
          };
          const Component = SECTION_COMPONENTS[contentType];

          return (
            <S.Wrapper key={id} ref={ref} {...styleProps}>
              <Component {...rest} />

              {!!optionalCtaButton && (
                <Badge
                  as="button"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                  onClick={() => setShowOverlay(true)}
                  hoverTextColor={
                    globalSettings?.buttonsHoverColor ||
                    globalSettings?.buttonsHoverDefaultColors
                  }
                >
                  <Text as="span" text={optionalCtaButton} size="button" />
                </Badge>
              )}
            </S.Wrapper>
          );
        }
      )}
      <Overlay isOpen={showOverlay} onExitClick={() => setShowOverlay(false)}>
        <CaseStudyOverlay {...overlay} caseStudy={caseStudy} />
      </Overlay>
    </>
  );
};

export default MultiSection;
